import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-original-upload" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-save" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-delete" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    items: _ctx.infos,
    columns: _ctx.columns,
    idProperty: "originalDocumentOrderId",
    ref: "grid",
    storageKey: "originalDocumentOrderListWidget"
  }, {
    type: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.participates ? _ctx.$t('original.list.toMyself') : _ctx.$t('original.list.fromMyself')), 1)
    ]),
    planNumber: _withCtx(({ item }) => [
      _createElementVNode("div", null, [
        _createElementVNode("b", null, _toDisplayString(item.documentVersionName), 1),
        _createTextVNode(" " + _toDisplayString(item.documentContent), 1)
      ])
    ]),
    planner: _withCtx(({ item }) => [
      _createElementVNode("b", null, _toDisplayString(item.documentOwnerMainParticipantGivenName) + " " + _toDisplayString(item.documentOwnerMainParticipantSurName), 1),
      _createTextVNode(" (" + _toDisplayString(item.documentOwnerMainParticipantOrganisationName) + ") ", 1)
    ]),
    requestedBy: _withCtx(({ item }) => [
      _createElementVNode("b", null, _toDisplayString(item.requestPersonGivenName) + " " + _toDisplayString(item.requestPersonSurName), 1),
      _createTextVNode(" (" + _toDisplayString(item.requestOrganisationName) + ") ", 1)
    ]),
    requestedFor: _withCtx(({ item }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (orderItem) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: orderItem.itemId
        }, [
          (orderItem.receiverPersonSurName != null && orderItem.receiverType == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("b", null, _toDisplayString(orderItem.receiverPersonGivenName) + " " + _toDisplayString(orderItem.receiverPersonSurName), 1),
                _createTextVNode(" (" + _toDisplayString(orderItem.receiverOrganisationName) + ") ", 1)
              ], 64))
            : (_openBlock(), _createElementBlock("b", _hoisted_1, [
                _createTextVNode(_toDisplayString(orderItem.receiverOrganisationName), 1),
                _hoisted_2
              ]))
        ], 64))
      }), 128))
    ]),
    date: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.requestFinished != null ?  _ctx.$d(new Date(item.requestFinished * 1000), { dateStyle: "short", timeStyle: "medium" }) : ""), 1)
    ]),
    request: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.requestComment ?? ""), 1)
    ]),
    acceptance: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.acceptanceComment ?? ""), 1)
    ]),
    status: _withCtx(({ item }) => [
      (item.acceptanceFinished != null && item.acceptanceAcceptedMode != null && item.acceptanceAcceptedMode !== 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$d(new Date(item.acceptanceFinished * 1000), { dateStyle: "short", timeStyle: "medium" })) + " " + _toDisplayString((() => {
            switch (item.acceptanceAcceptedMode) {
                case 1:
                return _ctx.$t('original.list.accepted');
                case 2:
                return _ctx.$t('original.list.rejected');
            }
        })()), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(({ item }) => [
      (item.mayProvideOriginal && !item.acceptanceFinished && item.originalDocumentOrderTaskId && this.ctx.activeSubProject != null && !this.ctx.activeSubProject.readOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-sm btn-outline-secondary",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('task.list.editOriginalDocumentRequest'),
            onClick: ($event: any) => (_ctx.requestOriginal(item))
          }, _hoisted_5, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (item.mayDownloadOriginal && item.originalDocumentOrderFilename)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-sm btn-outline-secondary",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('general.downloadFile'),
            onClick: ($event: any) => (_ctx.download(item))
          }, _hoisted_8, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (item.mayDeleteOriginalOrder && this.ctx.activeSubProject != null && !this.ctx.activeSubProject.readOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btn btn-sm btn-outline-secondary",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('original.list.deleteRequest'),
            onClick: ($event: any) => (_ctx.askDeleteOriginal(item))
          }, _hoisted_11, 8, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["items", "columns"]))
}